<template>
  <bita-modal
    id="sms-modal"
    title="شارژ پیامک"
    :modal-sm="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              ref="loading_fee"
              name="loading_fee"
              :label="$currencyLabel('مقدار شارژ')"
              rules="required|fee"
              validation-container-class="col-12"
              input-class="form-control"
              v-model="dataForm.amount"
              :has-thousand-seprator="true"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        type="primary"
        title="شارژ"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    settings: {},
  },
  data() {
    return {
      colWidth: "col-lg-12",
      dataForm: {},
      isLoading: false,
    };
  },
  watch: {
    settings: function(_val) {
      this.dataForm = _val;
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.isLoading = true;
          this.$persistClient("patch", "users/current/sms-credit", this.dataForm)
            .then((res) => {
              this.$toggleModal("#sms-modal");
              this.$root.$emit("update:smscredit");
              this.$root.$emit("update:balance");
            })
            .finally(() => (this.isLoading = false));
        }
      });
    },
    reset() {
      this.dataForm.amount = '';
      this.$refs.form.reset()
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
